// hooks/use-fetch-all-profiles.js
import { useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { fetchAllProfileByFilter } from "view/profile/store/services";
import { actions } from "view/search-profile/store/slice";
import { getItem } from "utils/local-storage";
import { errorToaster } from "utils/alerts";

export const useFetchAllProfiles = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchProfiles = useCallback(
    async (
      search,
      minAge,
      maxAge,
      rasi,
      sort,
      currentPage,
      profilesAvailability
    ) => {
      setLoading(true);
      setError(null);

      try {
        const response = await fetchAllProfileByFilter(
          getItem("the_main_app"),
          search,
          minAge,
          maxAge,
          rasi,
          sort,
          currentPage,
          profilesAvailability
        );

        dispatch(actions.setPageLimit(response.data.limit));
        dispatch(actions.setAllProfiles(response.data.values));
        dispatch(
          actions.setTotalPage(
            Math.ceil(response.data.total / response.data.limit)
          )
        );
        dispatch(actions.setCurrentPage(response.data.page));

        return response.data;
      } catch (err) {
        console.error("Error fetching profiles:", err);
        setError(err.message || "Failed to fetch profiles");
        errorToaster(err.message || "Failed to fetch profiles");
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [dispatch]
  );

  return {
    fetchProfiles,
    loading,
    error,
  };
};
